import { ref } from '@vue/composition-api'
import CustomerCustomFieldApi from '@/api/waiter/CustomerCustomField'
import { handleApiError } from '@/utils/errorHandler'

export default function useCustomerCustomFields(vm) {
  const customFields = ref([])
  const isLoading = ref(false)

  // プロパティ追加ダイアログ
  const propertyFormDialog = ref(false)
  const editingProperty = ref(null)

  // 削除確認ダイアログ
  const deleteConfirmDialog = ref(false)
  const deletingProperty = ref(null)

  const getCustomFields = async () => {
    isLoading.value = true
    try {
      const res = await CustomerCustomFieldApi.getCustomerCustomFields()
      if (res.data?.customerCustomFields?.data) {
        customFields.value = res.data.customerCustomFields.data.map(field => ({
          id: field.id,
          name: field.attributes.name,
          type: field.attributes.fieldType,
          position: field.attributes.position,
        }))
      }
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })
    } finally {
      isLoading.value = false
    }
  }

  const addCustomField = async ({
    name,
    type,
    position,
    callback,
  }) => {
    try {
      const res = await CustomerCustomFieldApi.createCustomerCustomField({
        name,
        field_type: type,
        position,
      })
      if (res.data?.customerCustomField?.data) {
        const field = res.data.customerCustomField.data
        customFields.value.push({
          id: field.id,
          name: field.attributes.name,
          type: field.attributes.fieldType,
          position: field.attributes.position,
        })
        vm.$toast.success('プロパティを追加しました')
        propertyFormDialog.value = false
      }
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })
    } finally {
      if (callback) callback()
    }
  }

  const updateCustomField = async (id, {
    name,
    position,
    callback,
  }) => {
    try {
      const res = await CustomerCustomFieldApi.updateCustomerCustomField(id, {
        name,
        position,
      })
      if (res.data?.customerCustomField?.data) {
        const field = res.data.customerCustomField.data
        const index = customFields.value.findIndex(f => String(f.id) === String(id))
        if (index >= 0) {
          customFields.value.splice(index, 1, {
            id: field.id,
            name: field.attributes.name,
            type: field.attributes.fieldType,
            position: field.attributes.position,
          })
        }
        vm.$toast.success('プロパティを更新しました')
        propertyFormDialog.value = false
        editingProperty.value = null
      }
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })
    } finally {
      if (callback) callback()
    }
  }

  const deleteCustomField = async (id, { callback }) => {
    try {
      await CustomerCustomFieldApi.deleteCustomerCustomField(id)
      const index = customFields.value.findIndex(f => String(f.id) === String(id))
      if (index >= 0) {
        customFields.value.splice(index, 1)
      }
      vm.$toast.success('プロパティを削除しました')
      deleteConfirmDialog.value = false
      deletingProperty.value = null
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })
    } finally {
      if (callback) callback()
    }
  }

  const openAddPropertyDialog = () => {
    editingProperty.value = null
    propertyFormDialog.value = true
  }

  const openEditPropertyDialog = property => {
    editingProperty.value = property
    propertyFormDialog.value = true
  }

  const confirmDeleteProperty = property => {
    deletingProperty.value = property
    deleteConfirmDialog.value = true
  }

  return {
    customFields,
    isLoading,
    propertyFormDialog,
    editingProperty,
    deleteConfirmDialog,
    deletingProperty,
    getCustomFields,
    addCustomField,
    updateCustomField,
    deleteCustomField,
    openAddPropertyDialog,
    openEditPropertyDialog,
    confirmDeleteProperty,
  }
}
